module.exports = __webpack_public_path__ + "static/img/isVideo.1182258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/classroomObservation/isVideo.png
// module id = 4+12
// module chunks = 4